// import { createStore } from 'redux'
// import { rootReducer } from './reducers/reducers'
// import { fileCheckout } from './actions/actions';

export let reactStore = {};

export function setReactStore(store) {
  reactStore = store;
}

//export const store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

// let reducer = combineReducers(reducers);
// export const store = $ngReduxProvider.createStoreWith(rootReducer);

// console.log(store.getState());
// console.log(store.dispatch(fileCheckout()));